import api from '@/api/index.js'

const account_season_tickets = {
  state: {
    loading: false,
    data: [],
    error: null
  },

  mutations: {
    SET_ACCOUNT_SEASON_TICKETS_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_ACCOUNT_SEASON_TICKETS: (state, topups) => {
      state.data = topups
      state.loading = false;
    },
    SET_ACCOUNT_SEASON_TICKETS_ERROR: (state, error) => {
      state.error = error
      state.loading = false;
    }
  },

  actions: {
    ListAccountSeasonTickets({commit}, id) {
      commit('SET_ACCOUNT_SEASON_TICKETS_LOADING', true)
      return api.get(`accounts/${id}/season-tickets?limit=150&offset=0`)
        .then((response) => {
          commit('SET_ACCOUNT_SEASON_TICKETS', response)
        })
        .catch((error) => {
          commit('SET_ACCOUNT_SEASON_TICKETS_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
        })
    }
  }
}

export default account_season_tickets
